import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AssociatedDocumentSignedEditionView } from "./AssociatedDocumentSignedEditionView";
import { AssociatedDocumentSignedEditionViewStore } from "../../store/AssociatedDocumentSignedEditionViewStore";
import { useStore } from "../../../../hooks";

export const AssociatedDocumentSignedEditionViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/associatedDocumentSignedEdition/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AssociatedDocumentSignedEditionViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AssociatedDocumentSignedEditionView
          associatedDocumentSignedEditionViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
